'use strict';

require('babel-polyfill');
module.exports = require('./neat-parser.js').default;
